import {Brick, registerBrick} from 'olympe';

export default class CheckCandexAuthorizationQuery extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} queryResult
     * @param {function()} forwardEvent
     * @param {function(array)} setCompanyCodesAuthorized
     */
    update($, [queryResult], [forwardEvent, setCompanyCodesAuthorized]) {
        const parsedResult = JSON.parse(queryResult);
        const allowedCompanyCodes = parsedResult
            .map((auth) => auth.company_code)
            .filter((n) => n);
        setCompanyCodesAuthorized(allowedCompanyCodes);
        forwardEvent();
    }
}

registerBrick('01956bf9e14bd0e5b086', CheckCandexAuthorizationQuery);
